import { downloadFileByUrl, PDF_FILE_LIST, showSnackBar } from 'consts';
import React from 'react';
import { IuserInfo } from 'reducer/common/userInfo';
import Button from 'tradevan-ui/Button';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import { EnumRetailerSetup } from 'view/Layout/enum';
import { IretailerSetupOrder } from '../OrderQuery/init';
import { IretailerSetupRcv } from '../RcvQuery/init';
import { EnumQueryConditions, IretailerSetupRtn } from '../RtnQuery/init';

interface DownloadAreaProps {
  /** order=訂單 rcv=驗收單 rtn=退貨單 */
  type: 'rtn' | 'rcv' | 'order';
  retailerSetup: IretailerSetupRtn | IretailerSetupOrder | IretailerSetupRcv;
  /** 目前選單的體系別value */
  retailerId: string;
  /** 透過 retailerId 去取得 retailerIds對應的name  */
  retailerIds: IuserInfo['retailerIds'];
}
/** 各功能操作手冊、物流中心退取須知 下載按鈕 */
const DownloadBtn = (props: DownloadAreaProps) => {
  const { type, retailerSetup, retailerId, retailerIds = [] } = props;

  /** 取得檔案 */
  const getOperationPdfUrl = () => {
    const find = PDF_FILE_LIST.find(
      (v) => v.toUpperCase() === retailerId.toUpperCase(),
    );
    if (find) {
      downloadFileByUrl(`/E-HUB2.0_${find}_Operation.pdf`);
    } else {
      showSnackBar('無對應的操作手冊，請聯絡系統管理員。', 'error', 3000);
    }
  };

  /** 判斷是否為退貨單，如果是，取其retailerSetup的queryConditions.extBtn設定 */
  const isRtn = (): boolean => {
    if (type === 'rtn') {
      const temp = (retailerSetup as IretailerSetupRtn)[
        EnumRetailerSetup.queryConditions
      ][EnumQueryConditions.extBtn];
      return temp;
    }
    return false;
  };

  return (
    <div className="btn-item float-right">
      {/* 只有退貨單會有【物流中心退取須知】 */}
      {isRtn() && (
        <Button
          variant={ButtonVariantEnum.warning}
          rounded
          size="sm"
          onClick={() => {
            downloadFileByUrl('/CitySuperReturnNotes.pdf');
          }}
        >
          物流中心退取須知
        </Button>
      )}
      {retailerId && (
        <>
          <span style={{ marginRight: '0.5rem' }} />
          <Button
            variant={ButtonVariantEnum.warning}
            rounded
            size="sm"
            onClick={() => {
              getOperationPdfUrl();
            }}
          >
            {retailerIds.find((v) => v.retailerId === retailerId)?.retailerName}
            操作手冊
          </Button>
        </>
      )}
    </div>
  );
};
export default DownloadBtn;
